// extracted by mini-css-extract-plugin
export default {"container":"Panel_container__VXKLo"};